import React, { createContext, useState, useContext } from "react";

// Create a context for loading state
const LoadingContext = createContext();

// Create a custom hook to use the loading context
export const useLoading = () => useContext(LoadingContext);

// Loading provider to manage loading state globally
export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingTimeout, setLoadingTimeout] = useState(null);

  const startLoading = () => {
    setIsLoading(true);

    // Safety timeout - force stop loading after 10 seconds
    const timeout = setTimeout(() => {
      console.warn("Force stopping loading after timeout");
      setIsLoading(false);
    }, 10000);
    setLoadingTimeout(timeout);
  };

  const stopLoading = () => {
    setIsLoading(false);
    if (loadingTimeout) {
      clearTimeout(loadingTimeout);
      setLoadingTimeout(null);
    }
  };

  return (
    <LoadingContext.Provider value={{ isLoading, startLoading, stopLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};
